import React, { FC, useEffect, useState } from 'react';
import AMapLoader from '@amap/amap-jsapi-loader';
import { aMapKey } from '../config-v2';

const Amap: FC<any> = ({
  width = '100%',
  height = '100%',
  styleOpt = {},
  key = aMapKey,
  version = '2.0', // 默认最新的2.0版本
  plugins = [],
  AMapUI = {},
  config = {}, // 其他高德地图的配置项
  mapOpts = {},
  loaded = () => {},
  children
}) => {
  const [mapIns, setMapIns] = useState<any>(null); // 地图实例
  const [mapDom, setMapDom] = useState<any>(null); // 地图DOM

  useEffect(() => {
    mapDom && !mapIns && init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapDom]);

  const targetDom = (dom: any) => {
    setMapDom(dom);
  };
  const destroyMapWebgl = () => {
    (mapDom.querySelector(`canvas.amap-layer`) as any)?.getContext('webgl')?.getExtension('WEBGL_lose_context')?.loseContext();
  };
  useEffect(() => {
    return () => {
      if (mapIns) {
        destroyMapWebgl();
        mapIns.remove(mapIns.getLayers(), mapIns.getAllOverlays());
        mapIns.destroy();
        setMapIns(null);
      }
    };
  }, [mapIns]);

  const init = async () => {
    // https://lbs.amap.com/api/jsapi-v2/guide/abc/load
    await AMapLoader.load({
      key, // 申请好的Web端开发者Key，首次调用 load 时必填
      version, // 指定要加载的 JSAPI 的版本，默认为 2.0
      plugins, // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      AMapUI,
      ...config
    }).finally(() => {
      if (!window.AMap) {
        return;
      }

      const map = new window.AMap.Map(mapDom, mapOpts);
      setMapIns(map);
      loaded(map, mapDom);
    });
  };

  // 自定义组件时，默认注入地图实例和地图DOM
  const renderChildren = () => {
    return (
      React.Children.map(children, (child: any) => {
        if (!child) return child;
        const { props } = child;
        // 明确声明preventAmap不需要注入的不注入地图相关属性
        if (props && props.preventAmap) {
          return child;
        }
        // 默认注入地图实例和地图DOM
        return React.cloneElement(child, {
          _mapIns: mapIns,
          _mapDom: mapDom
        });
      })
    );
  };

  return (
    <div
      style={{
        width,
        height,
        ...styleOpt
      }}
    >
      {/* 地图dom */}
      <div
        ref={(dom) => targetDom(dom)}
        style={{
          width: '100%',
          height: '100%'
        }}>
      </div>
      {/* 自定义组件  */}
      {
        mapIns && renderChildren()
      }
    </div>
  );
};

export default Amap;


// 用法
// import { FC, useState } from 'react';
// import { Button } from 'antd';
// import AMap from '@/common/components/AMap/index';
// import Marker from './components/Marker';

// import styles from './entry.module.less';
// const Map: FC<any> = () => {
//   const [visible, setVisible] = useState<boolean>(false);
//   // 地图加载完成
//   const loadedMapHandle = (map, dom) => {
//     console.log(`map`, map);
//     console.log(`dom`, dom);
//   };

//   const otherMapLoadedHandle = (map, dom) => {
//     console.log(`地图二：map`, map);
//     console.log(`地图二：dom`, dom);
//   };

//   return (
//     <div className={styles.container}>
//       <Button type='primary' onClick={() => setVisible(!visible)}>{ visible ? '隐藏' : '显示' }</Button>
//       {
//         visible && <AMap loaded={loadedMapHandle}/>
//       }
//       <div className=''>
//         <AMap loaded={otherMapLoadedHandle} width='500px' height='350px'>
//           <Marker/>
//         </AMap>
//       </div>
//     </div>
//   );
// };

// export default Map;


// import { FC, useEffect } from 'react';

// const Marker: FC<any> = ({
//   _mapIns,
//   _mapDom
// }) => {
//   console.log(`marker`, _mapIns, _mapDom);
//   useEffect(() => {

//   }, []);

//   return (
//     <>

//     </>
//   );
// };

// export default Marker;


